import { Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { StandaloneTankTATEnum } from "../../common/enums/StandaloneTankTATEnum";
import { getTotalFromFeetAndInchesText } from "../../common/utilities/FeetAndInches";
import { useUserContext } from "../../contexts/user-context/UserContext";
import { ITankTagDisplayValue } from "./CompoundTankUtils";

export type CompoundTankTagDisplayValueProps = {
    tagValues: ITankTagDisplayValue[],
    overflow?: boolean;
}

export default function CompoundTankTagDisplayValue({
    tagValues,
    overflow
}: CompoundTankTagDisplayValueProps) {

    const [userState] = useUserContext();

    const values = useMemo(() => {
        const topLevel = tagValues.find(o => o.tatID === StandaloneTankTATEnum.LiquidHeight);
        return {
            topLevel,
        };
    }, [
        tagValues
    ]);

    function renderRow(value: ITankTagDisplayValue | undefined) {
        return (
            <Stack
                direction='row'
                sx={{
                    justifyContent: 'space-between',
                    marginLeft: 'auto!important',
                    marginRight: 'auto!important',
                    '&+&': {
                        marginTop: 1,
                    },
                    color: overflow
                        ? "red"
                        : "inherit",
                }}
            >
                {value &&
                    <Stack direction='column'>
                        <Typography
                            variant="body2"
                            sx={{
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                                minWidth: 110,
                                color: overflow
                                    ? "red"
                                    : "inherit"
                            }}
                        >
                            {value.name}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                textAlign: 'center',
                                fontWeight: 600,
                                padding: 1,
                                borderColor: theme => overflow
                                    ? "red"
                                    : theme.palette.grey[600],
                                minWidth: 110,
                                borderWidth: '1px',
                                borderStyle: 'solid',
                                whiteSpace: 'nowrap'
                            }}>

                            {userState.userSettings?.tankLevelInches
                                ? `${getTotalFromFeetAndInchesText(value.value)} Inches`
                                : value.value
                            }
                        </Typography>
                    </Stack>
                }
            </Stack>
        );
    }

    return (
        <Stack
            direction='column'
            sx={{
                marginLeft: 'auto!important',
                marginRight: 'auto!important',
            }}
        >
            {renderRow(values.topLevel)}
        </Stack>
    );
}
